<template>
  <div :class="divWidthChange" class="conteudoWidth fccObjetos">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row buttonsOptions">
      <div class="col-sm-12">
        <button
          v-b-tooltip.hover
          title="Voltar"
          @click="$router.push({ path: '/seguranca/aplicacoes' })"
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon icon="chevron-left" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <draggable :list="objetoFinal" class="list-group" ghost-class="ghost" @end="dragMenu">
          <div
            class="list-group-item"
            :class="{ inactive: !element.objativo }"
            v-for="element in objetoFinal"
            :key="element.objnome"
          >
            <span class="handleIcon"><font-awesome-icon icon="grip-vertical" size="sm" /></span>
            {{ element.objnome }}
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import axios from 'axios'
import './assets/fccObjetos.scss'
import draggable from 'vuedraggable'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Ordenando Menu Principal',
      titleModal: '',
      listaObjetos: {},
      menu: {},
      objparent: '',
      objetoFinal: [],
      objetoReserva: []
    }
  },
  components: { draggable },
  methods: {
    dragMenu: async function () {
      await this.listandoOrdem(this.objetoFinal)
      this.callToast(this.mensagensUpdate.editado, 'success')
    },
    listandoOrdem: async function (lista) {
      for (var [key, listando] of Object.entries(lista)) {
        var lstCria = {
          objnome: listando.objnome,
          objid: listando.objid,
          objparent: 0,
          appid: listando.appid,
          objhashcode: listando.objhashcode,
          objativo: listando.objativo,
          objordem: key,
          objtipID: 1
        }
        this.editandoOrdem(lstCria)
      }
    },
    editandoOrdem: function (menu) {
      axios
        .put(this.baseUrlSeguranca + 'Objeto/Alterar', menu, this.dadosLoginSession.fccTokenHeaders)
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoObjetos: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Menu/listarmenuprincipal',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.objetoFinal = response.data
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.objetoId = this.$route.params.id
    this.listandoObjetos(1)
  }
}
</script>
